/**
 * @generated SignedSource<<9c54bcd4000136e1841e905d924a4aab>>
 * @relayHash 662433107c26893627499879ab359172
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 324a4aa216cdb600c1a049b983a99f7fa3d5d893dc1bade53f799da17aa5a27d

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DynamicIslandProfileExpandQuery$variables = Record<PropertyKey, never>;
export type DynamicIslandProfileExpandQuery$data = {
  readonly viewer: {
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  } | null | undefined;
};
export type DynamicIslandProfileExpandQuery = {
  response: DynamicIslandProfileExpandQuery$data;
  variables: DynamicIslandProfileExpandQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v2 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v3 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v4 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DynamicIslandProfileExpandQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPrimaryPhotoNew_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DynamicIslandProfileExpandQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailMd5",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "primaryPhoto",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "fit",
                        "value": "cover"
                      },
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "transform"
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":100,\"w\":100})"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "transform"
              }
            ],
            "kind": "ScalarField",
            "name": "defaultAvatarUrl",
            "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":100,\"w\":100})"
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "324a4aa216cdb600c1a049b983a99f7fa3d5d893dc1bade53f799da17aa5a27d",
    "metadata": {},
    "name": "DynamicIslandProfileExpandQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0ecb67906b76995cba60deef85e14096";

export default node;
